// extracted by mini-css-extract-plugin
export default {"footer":"_347ZV","moreItemsText":"fgAz7","mobileFooter":"YuikN"};